import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import CarouselItem from '../components/CarouselItem';
import FlipperCard from '../components/flipperCard';
import styles from '../styles/projects.module.css';

const Projects = () => {
  const location = useLocation();
  const [index, setIndex] = useState(0);
  const [webProjects, setWebProjects] = useState([]);
  const [otherProjects, setOtherProjects] = useState([]);

  useEffect(() => {
    axios.get(`/api/projects/web`)
      .then(response => {
          setWebProjects(response.data.projects);
            // Check if there's a projectId query parameter
          const queryParams = new URLSearchParams(location.search);
          const projectId = queryParams.get('projectId');
          const webProject = queryParams.get('webProject');
          const isWebProject = webProject === 'true';
          
          if (projectId && isWebProject) {
            const projectIndex = response.data.projects.findIndex(project => project.id === parseInt(projectId));
            if (projectIndex !== -1) {
              setIndex(projectIndex);
            }
          } else if (projectId && !isWebProject){
            const otherProjectsDiv = document.getElementById('otherProjects');
            if (otherProjectsDiv) {
              otherProjectsDiv.scrollIntoView({ behavior: 'smooth' }); // Scrolls smoothly to the div
            }
          }
      })
      .catch(error => {
          console.error(`Error fetching web projects`, error)
      })

    axios.get(`/api/projects/other`)
      .then(response => {
          setOtherProjects(response.data.projects);
      })
      .catch(error => {
          console.error(`Error fetching other projects`, error)
      })
  }, [location.search])

  const numItems = webProjects.length;

  const handleNext = () => {
    setIndex((prevIndex) => (prevIndex + 1) % numItems); // Cycle through 4 items
  };

  const handlePrev = () => {
    setIndex((prevIndex) => (prevIndex - 1 + numItems) % numItems); // Cycle through 4 items
  };

    return (
      <>
        <div className={styles.carousel}>
          <h1 className={styles.pageHead}>WEB PROJECTS</h1>
          {webProjects.map((item, i) => (
            <CarouselItem
              key={i}
              index={i}
              currentIndex={index}
              image={item.images.homepage}
              mobileImage={item.images.mobile}
              text={{title: item.project_name, description: item.description}}
              link={item.link}
              skills={item.skills}
              numItems = {numItems}
            />
          ))}

          <div className={styles.buttons}>
            <span className={styles.prev} onClick={handlePrev}>Prev</span>
            <span className={styles.next} onClick={handleNext}>Next</span>
          </div>
        </div>

        <div id="otherProjects" className={styles.otherProjects}>
          <h1 className={styles.pageHead}>OTHER PROJECTS</h1>
          <section>
            <div className={styles.otherRow}>
              {otherProjects.map((item, i) => (
                <FlipperCard
                  key={i}
                  index={i}
                  image={item.images[Object.keys(item.images)[0]]}
                  text={{title: item.project_name, description: item.description}}
                  link={item.link}
                  skills={item.skills}
                />
              ))}
              </div>
              <h3 className={styles.moreToCome}>MORE TO COME...</h3>
          </section>
        </div>
      </>
    );
  };
  
export default Projects;